// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accent-color: #28a745;
  --danger-color: #dc3545;
  --warning-color: #ffc107;
  --info-color: #17a2b8;
  --text-color-dark: #343a40;
  --text-color-medium: #6c757d;
  --text-color-light: #f8f9fa;
  --card-bg: #ffffff;
  --container-bg: #f8f9fa;
  --border-color: #e9ecef;
  --shadow-light: rgba(0, 0, 0, 0.08);
  --shadow-medium: rgba(0, 0, 0, 0.15);
  --spacing-unit: 0.75rem;
}

.note-container {
  padding: calc(var(--spacing-unit) * 2);
  background: var(--container-bg);
  position: relative;
  z-index: 1;
}
.note-container .filter-group label {
  display: block;
  margin-bottom: 8px;
}

.note-grid {
  display: grid;
  margin-top: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: calc(var(--spacing-unit) * 2);
  padding: 0;
  background-color: transparent;
}

.view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.view-toggle-wrapper .view-toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.view-toggle-wrapper .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.view-toggle-wrapper .view-toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}

.note-main-card {
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  padding: calc(var(--spacing-unit) * 2);
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}
.note-main-card .note-courtRef-tag {
  background-color: #f0f0f0;
  color: var(--text-color-medium);
  padding: 0.2em 0.6em;
  border-radius: 0.25em;
  font-size: 0.8em;
  font-weight: 500;
  border: 1px solid #d4d4d4;
  display: inline-block;
  cursor: pointer;
  line-height: 1.2rem;
}
.note-main-card .note-footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}
.note-main-card .note-footer .created-date {
  color: var(--text-color-medium);
  font-size: 0.75rem;
}
.note-main-card .note-main-card-header {
  display: flex;
  gap: 0.2rem;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
  padding-bottom: var(--spacing-unit);
  border-bottom: 1px solid var(--border-color);
}
.note-main-card .note-main-card-header .note-title-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  flex-grow: 1;
}
.note-main-card .note-main-card-header .note-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-color-dark);
  margin: 0;
  line-height: 1.2;
}
.note-main-card .note-main-card-header .note-main-card-actions {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}
.note-main-card .note-main-card-header .note-main-card-actions .action-button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.note-main-card .note-main-card-header .note-main-card-actions .action-button:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.note-main-card .note-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.75rem 1rem;
  margin-bottom: calc(var(--spacing-unit) * 1.5);
  font-size: 0.95rem;
  color: var(--text-color-medium);
  margin-top: 0.5rem;
}
.note-main-card .note-details-grid .detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.note-main-card .note-details-grid .detail-icon {
  color: var(--primary-color);
  font-size: 1.15rem;
  flex-shrink: 0;
}
.note-main-card .note-details-grid .detail-label {
  font-weight: 600;
  color: var(--text-color-dark);
  flex-shrink: 0;
}
.note-main-card .note-details-grid .detail-value {
  font-weight: 500;
  color: var(--text-color-dark);
  word-break: break-word;
}
.note-main-card .note-content-area {
  margin-top: var(--spacing-unit);
  padding: var(--spacing-unit);
  background-color: #f9fafb;
  border-radius: 0.5rem;
  border: 1px solid var(--border-color);
  overflow-wrap: break-word;
  word-wrap: break-word;
}
.note-main-card .note-content-area .note-content {
  font-size: 0.85rem;
  line-height: 1.6;
  color: var(--text-color-medium);
  margin: 0;
  white-space: pre-wrap;
}

.no-notes-found {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}

.notes-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.notes-table thead {
  background-color: #f1f5f9;
}
.notes-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.notes-table tbody tr {
  transition: background-color 0.2s ease;
}
.notes-table tbody tr:hover {
  background-color: #f9fafb;
}
.notes-table tbody tr td {
  padding: 0.9rem 1rem;
}
.notes-table tbody tr td:last-child {
  white-space: nowrap;
}
.notes-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #17a2b8;
  color: white;
}
.notes-table tbody tr td:last-child button:last-child {
  background-color: #dc2626;
}
.notes-table tbody tr td:last-child button:hover {
  opacity: 0.9;
}

.pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}
.pagination-settings #notePerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.pagination-settings #notePerPageSelect:hover {
  background-color: #fafafa;
}
.pagination-settings #notePerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.pagination-settings #notePerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}

@media (max-width: 768px) {
  .note-container {
    padding: var(--spacing-unit);
  }
  .note-grid {
    gap: var(--spacing-unit);
    grid-template-columns: 1fr;
  }
  .note-main-card {
    padding: calc(var(--spacing-unit) * 1.5);
  }
  .note-main-card .note-main-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: var(--spacing-unit);
  }
  .note-main-card .note-main-card-header .note-main-card-actions {
    align-self: flex-end;
  }
  .note-main-card .note-details-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin-bottom: var(--spacing-unit);
  }
  .note-main-card .note-content-area .note-content {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .note-container {
    padding: calc(var(--spacing-unit) * 0.5);
  }
  .note-main-card {
    padding: var(--spacing-unit);
  }
  .note-main-card .note-main-card-header .note-title {
    font-size: 1.1rem;
  }
  .note-main-card .note-details-grid .detail-item {
    font-size: 0.85rem;
  }
  .note-main-card .note-details-grid .detail-item .detail-icon {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Notes/Note.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,0BAAA;EACA,4BAAA;EACA,2BAAA;EAEA,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mCAAA;EACA,oCAAA;EACA,uBAAA;AADF;;AAIA;EACE,sCAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;AADF;AAEE;EACE,cAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,gBAAA;EACA,2DAAA;EACA,kCAAA;EACA,UAAA;EACA,6BAAA;AADF;;AAKA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAFJ;AAII;EACE,eAAA;EACA,cAAA;AAFN;AAKI;EACE,yBAAA;AAHN;AAMI;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAJN;;AAWA;EACE,0BAAA;EACA,qCAAA;EACA,sBAAA;EACA,sCAAA;EACA,gCAAA;EACA,eAAA;AARF;AAUE;EACE,yBAAA;EACA,+BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AARJ;AAeC;EACG,gBAAA;EACA,iBAAA;EACA,yCAAA;AAbJ;AAeI;EACE,+BAAA;EACA,kBAAA;AAbN;AAgBE;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,uBAAA;EACA,qBAAA;EACA,mCAAA;EACA,4CAAA;AAdJ;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AAdN;AAkBI;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AAhBN;AAqBI;EACE,aAAA;EACA,YAAA;EACA,cAAA;AAnBN;AAqBM;EAWI,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA7BV;AA+BQ;EACE,+BAAA;EACA,YAAA;AA7BV;AAmCE;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;EACA,8CAAA;EACA,kBAAA;EACA,+BAAA;EACA,kBAAA;AAjCJ;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAjCN;AAoCI;EACE,2BAAA;EACA,kBAAA;EACA,cAAA;AAlCN;AAqCI;EACE,gBAAA;EACA,6BAAA;EACA,cAAA;AAnCN;AAsCI;EACE,gBAAA;EACA,6BAAA;EACA,sBAAA;AApCN;AAwCE;EACE,+BAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,qCAAA;EACA,yBAAA;EACA,qBAAA;AAtCJ;AAwCI;EACE,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,qBAAA;AAtCN;;AA2CA;EAEE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACC,iBAAA;AAzCH;;AA4CA;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAzCF;AA2CE;EACM,yBAAA;AAzCR;AA2CI;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AAzCN;AA+CI;EACE,sCAAA;AA7CN;AA+CM;EACE,yBAAA;AA7CR;AAgDM;EACE,oBAAA;AA9CR;AAkDM;EACE,mBAAA;AAhDR;AAkDQ;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAhDV;AAkDU;EACE,yBAAA;AAhDZ;AAmDU;EACE,YAAA;AAjDZ;;AAyDE;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAtDF;AAyDE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvDJ;AA2DE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AA/DJ;AAkEI;EACE,yBAAA;AAhEN;AAoEI;EACE,wDAAA;EACA,uBAAA;AAlEN;AAsEI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AApEN;;AAyEA;EACE;IACE,4BAAA;EAtEF;EAyEA;IACE,wBAAA;IACA,0BAAA;EAvEF;EA0EA;IACE,wCAAA;EAxEF;EA0EE;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;IACA,kCAAA;EAxEJ;EA0EI;IACE,oBAAA;EAxEN;EA4EE;IACE,0BAAA;IACA,WAAA;IACA,kCAAA;EA1EJ;EA8EI;IACE,kBAAA;EA5EN;AACF;AAiFA;EACE;IACE,wCAAA;EA/EF;EAkFA;IACE,4BAAA;EAhFF;EAmFI;IACE,iBAAA;EAjFN;EAsFI;IACE,kBAAA;EApFN;EAsFM;IACE,eAAA;EApFR;AACF","sourcesContent":[":root {\r\n  --accent-color: #28a745;\r\n  --danger-color: #dc3545;\r\n  --warning-color: #ffc107;\r\n  --info-color: #17a2b8;\r\n\r\n  --text-color-dark: #343a40;\r\n  --text-color-medium: #6c757d;\r\n  --text-color-light: #f8f9fa;\r\n\r\n  --card-bg: #ffffff;\r\n  --container-bg: #f8f9fa;\r\n  --border-color: #e9ecef;\r\n  --shadow-light: rgba(0, 0, 0, 0.08);\r\n  --shadow-medium: rgba(0, 0, 0, 0.15);\r\n  --spacing-unit: 0.75rem;\r\n}\r\n\r\n.note-container {\r\n  padding: calc(var(--spacing-unit) * 2);\r\n  background: var(--container-bg);\r\n  position: relative;\r\n  z-index: 1;\r\n  .filter-group label{\r\n    display: block;\r\n    margin-bottom: 8px;\r\n  }\r\n}\r\n\r\n.note-grid {\r\n  display: grid;\r\n  margin-top: 1rem;\r\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\r\n  gap: calc(var(--spacing-unit) * 2);\r\n  padding: 0;\r\n  background-color: transparent;\r\n\r\n}\r\n\r\n.view-toggle-wrapper {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  align-items: center;\r\n\r\n  .view-toggle-btn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.3rem;\r\n    padding: 0.3rem 0.6rem;\r\n    font-size: 0.85rem;\r\n    font-weight: 500;\r\n    background-color: transparent;\r\n    color: #444;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n\r\n    svg {\r\n      font-size: 1rem;\r\n      color: inherit;\r\n    }\r\n\r\n    &:hover {\r\n      background-color: #f3f4f6;\r\n    }\r\n\r\n    &.active {\r\n      background-color: #e5e7eb;\r\n      color: #222;\r\n      border-color: #cbd5e1;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.note-main-card {\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 0.75rem;\r\n  padding: calc(var(--spacing-unit) * 2);\r\n  transition: all 0.2s ease-in-out;\r\n  cursor: pointer;\r\n\r\n  .note-courtRef-tag {\r\n    background-color: #f0f0f0;\r\n    color: var(--text-color-medium);\r\n    padding: 0.2em 0.6em;\r\n    border-radius: 0.25em;\r\n    font-size: 0.8em;\r\n    font-weight: 500;\r\n    border: 1px solid #d4d4d4;\r\n    display: inline-block;\r\n    cursor: pointer;\r\n    line-height: 1.2rem;\r\n  }\r\n\r\n  // &:hover {\r\n  //   box-shadow: 0 6px 15px var(--shadow-light);\r\n  //   transform: translateY(-1px);\r\n  // }\r\n .note-footer {\r\n    margin-top:1rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid var(--border-color);\r\n\r\n    .created-date {\r\n      color: var(--text-color-medium);\r\n      font-size: 0.75rem;\r\n    }\r\n  }\r\n  .note-main-card-header {\r\n    display: flex;\r\n    gap: 0.2rem;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    margin-bottom: 0.5rem;\r\n    padding-bottom: var(--spacing-unit);\r\n    border-bottom: 1px solid var(--border-color);\r\n\r\n    .note-title-group {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 0.25rem;\r\n      flex-grow: 1;\r\n\r\n    }\r\n\r\n    .note-title {\r\n      font-size: 1.1rem;\r\n      font-weight: 700;\r\n      color: var(--text-color-dark);\r\n      margin: 0;\r\n      line-height: 1.2;\r\n    }\r\n\r\n\r\n\r\n    .note-main-card-actions {\r\n      display: flex;\r\n      gap: 0.75rem;\r\n      flex-shrink: 0;\r\n\r\n      .action-button {\r\n        // background: none;\r\n        // border: 1px solid var(--border-color);\r\n        // border-radius: 50%;\r\n        // width: 1.8rem;\r\n        // height: 1.8rem;\r\n        // display: flex;\r\n        // align-items: center;\r\n        // justify-content: center;\r\n        // cursor: pointer;\r\n        // transition: all 0.2s ease;\r\n          margin-right: 0.5rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          border: none;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n\r\n        &:hover {\r\n          background: var(--container-bg);\r\n          opacity: 0.9;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .note-details-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n    gap: 0.75rem 1rem;\r\n    margin-bottom: calc(var(--spacing-unit) * 1.5);\r\n    font-size: 0.95rem;\r\n    color: var(--text-color-medium);\r\n    margin-top: 0.5rem;\r\n\r\n    .detail-item {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    .detail-icon {\r\n      color: var(--primary-color);\r\n      font-size: 1.15rem;\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    .detail-label {\r\n      font-weight: 600;\r\n      color: var(--text-color-dark);\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    .detail-value {\r\n      font-weight: 500;\r\n      color: var(--text-color-dark);\r\n      word-break: break-word;\r\n    }\r\n  }\r\n\r\n  .note-content-area {\r\n    margin-top: var(--spacing-unit);\r\n    padding: var(--spacing-unit);\r\n    background-color: #f9fafb;\r\n    border-radius: 0.5rem;\r\n    border: 1px solid var(--border-color);\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n\r\n    .note-content {\r\n      font-size: 0.85rem;\r\n      line-height: 1.6;\r\n      color: var(--text-color-medium);\r\n      margin: 0;\r\n      white-space: pre-wrap;\r\n    }\r\n  }\r\n}\r\n\r\n.no-notes-found {\r\n  //width: 100%;\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n  color: var(--text-color-medium);\r\n  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\r\n  background: var(--card-bg);\r\n  border-radius: 0.75rem;\r\n  border: 1px dashed var(--border-color);\r\n  box-shadow: 0 2px 5px var(--shadow-light);\r\n  margin-top: calc(var(--spacing-unit) * 2);\r\n   grid-column: 1 / -1; \r\n}\r\n\r\n.notes-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background-color: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 0.5rem;\r\n  overflow: hidden;\r\n  font-size: 0.95rem;\r\n  box-shadow: 0 2px 6px var(--shadow-light);\r\n\r\n  thead {\r\n        background-color: #f1f5f9;\r\n\r\n    th {\r\n      text-align: left;\r\n      padding: 1rem;\r\n      color: #111827;\r\n      // border: 1px solid #ddd;\r\n    }\r\n  }\r\n\r\n  tbody {\r\n    tr {\r\n      transition: background-color 0.2s ease;\r\n\r\n      &:hover {\r\n        background-color: #f9fafb;\r\n      }\r\n\r\n      td {\r\n        padding: 0.9rem 1rem;\r\n        // border: 1px solid #ddd;\r\n      }\r\n\r\n      td:last-child {\r\n        white-space: nowrap;\r\n\r\n        button {\r\n          margin-right: 0.5rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          border: none;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n          background-color: #17a2b8;\r\n          color: white;\r\n\r\n          &:last-child {\r\n            background-color: #dc2626; // red for delete\r\n          }\r\n\r\n          &:hover {\r\n            opacity: 0.9;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n  .pagination-settings {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  padding: 7px 18px;\r\n  background-color: #E2E8F0;\r\n  border-radius: 6px;\r\n\r\n\r\n  label {\r\n    white-space: nowrap;\r\n    color: #1f2937;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n  #notePerPageSelect {\r\n    border: none;\r\n    border-radius: 6px;\r\n    outline: none;\r\n    padding: 6px 32px 6px 12px;\r\n    background-color: white;\r\n    font-size: 14px;\r\n    color: #333;\r\n    cursor: pointer;\r\n    min-width: 70px;\r\n\r\n\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n\r\n\r\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center;\r\n    background-size: 16px;\r\n\r\n\r\n    transition: all 0.2s ease;\r\n    box-shadow: none !important;\r\n\r\n\r\n    &:hover {\r\n      background-color: #fafafa;\r\n    }\r\n\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\r\n      background-color: white;\r\n    }\r\n\r\n\r\n    option {\r\n      border: none !important;\r\n      outline: none;\r\n      padding: 4px 8px;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .note-container {\r\n    padding: var(--spacing-unit);\r\n  }\r\n\r\n  .note-grid {\r\n    gap: var(--spacing-unit);\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .note-main-card {\r\n    padding: calc(var(--spacing-unit) * 1.5);\r\n\r\n    .note-main-card-header {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 0.75rem;\r\n      margin-bottom: var(--spacing-unit);\r\n\r\n      .note-main-card-actions {\r\n        align-self: flex-end;\r\n      }\r\n    }\r\n\r\n    .note-details-grid {\r\n      grid-template-columns: 1fr;\r\n      gap: 0.5rem;\r\n      margin-bottom: var(--spacing-unit);\r\n    }\r\n\r\n    .note-content-area {\r\n      .note-content {\r\n        font-size: 0.85rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .note-container {\r\n    padding: calc(var(--spacing-unit) * 0.5);\r\n  }\r\n\r\n  .note-main-card {\r\n    padding: var(--spacing-unit);\r\n\r\n    .note-main-card-header {\r\n      .note-title {\r\n        font-size: 1.1rem;\r\n      }\r\n    }\r\n\r\n    .note-details-grid {\r\n      .detail-item {\r\n        font-size: 0.85rem;\r\n\r\n        .detail-icon {\r\n          font-size: 1rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
